export default __webpack_public_path__ + "static/media/guitar_active.26e11f4e.svg";